/* tslint:disable */
/* eslint-disable */
import { Function } from '../enums/function';
export { Function }
